<template>
  <div>
    <div style="display: flex; align-items: center;  margin-bottom: 16px;">
      <v-btn
        class="q-orange-bk q-text-whitesmoke"
        @click="generate"
        style="min-width: 120px; font-size: 16px;"
      >
        {{ getString("Nuovo") }}
      </v-btn>
      <span style="color: #555; font-size: 15px;" v-if="maxEmployees > 0">
        {{
          getString(
            "Hai ancora " +
              (maxEmployees + 1 - employees.length) +
              " di " +
              maxEmployees +
              " dipendenti disponibili"
          )
        }}
      </span>
    </div>
    <v-layout column v-if="shopLoad" align-center>
      <!--
        <v-progress-circular style="margin-top:100px" color="red lighten-3" size="64" indeterminate></v-progress-circular>
      -->
      <progress-q></progress-q>
    </v-layout>
    <v-layout class="loading" column v-if="isLoading" align-center>
      <div class="loading background"></div>
      <progress-q></progress-q>
    </v-layout>
    <draggable
      v-model="draggableEmployees"
      :options="sortOptions"
      @update="updateSort"
      class="draggable-grid row wrap"
      style="display: flex; flex-wrap: wrap; width: 100%; align-items: stretch"
    >
      <template v-for="(item, index) in draggableEmployees">
        <v-flex
          style="height: 100%; min-height: 500px; display: flex"
          xs12
          sm6
          md4
          lg3
          :class="responsiveGridClass"
          :key="item.idEmployee"
          v-if="item.idEmployee !== -1"
        >
          <v-card v-if="!shopLoad" class="dash-card" height="100%">
            <div class="hide" v-if="!canAdd && index > 1">
              <h1>{{ getString("Solo utenti Silver o Platinum") }}</h1>
            </div>
            <v-layout column align-center style="position: relative">
              <v-icon
                class="handle q-orange-bk q-text-whitesmoke"
                style="
                  position: absolute;
                  top: 0;
                  left: 0;
                  cursor: move;
                  margin: 5px;
                  border-radius: 10px;
                  padding: 5px;
                "
                >drag_indicator</v-icon
              >
              <img
                :src="defaultAvatar(item)"
                onerror="this.src='/../../../static/img/default-avatar.png';"
                ref="avatar"
                class="avatar-img elevation-3"
              />
              <v-btn
                style="position: absolute; bottom: 0"
                class="q-orange-bk q-text-whitesmoke"
                @click="showPicker(item)"
                >{{ getString("Cambia immagine") }}</v-btn
              >

              <v-btn
                icon
                style="position: absolute; top: 0; right: 0"
                class="q-orange-bk q-text-whitesmoke"
                @click="showDelete(item)"
              >
                <v-icon>delete</v-icon>
              </v-btn>
            </v-layout>
            <v-card-title primary-title>
              <v-layout
                style="align-items: center; justify-content: space-between"
              >
                <h3
                  v-show="!nameShow[index]"
                  class="headline mb-0"
                  style="
                    overflow: hidden;

                    text-overflow: ellipsis;
                  "
                >
                  {{ item.name }}
                </h3>
                <v-text-field
                  v-model="newName"
                  color="red darken-1"
                  flat
                  v-show="nameShow[index]"
                  :placeholder="getString('Nuovo nome')"
                ></v-text-field>
                <v-tooltip bottom v-if="!nameShow[index]">
                  <template slot="activator">
                    <v-btn
                      icon
                      class="q-orange-bk q-text-whitesmoke"
                      @click="showTheName(index, item)"
                    >
                      <v-icon>edit</v-icon></v-btn
                    >
                  </template>
                  <span>Modifica nome</span>
                </v-tooltip>
                <v-tooltip bottom v-if="nameShow[index]">
                  <template slot="activator">
                    <v-btn
                      icon
                      class="q-orange-bk q-text-whitesmoke"
                      @click="showTheName(index, item)"
                      ><v-icon v-if="nameShow[index]">save</v-icon>
                    </v-btn>
                  </template>
                  <span>Salva nome</span>
                </v-tooltip>
              </v-layout>
            </v-card-title>
            <v-card-text>
              <v-layout column>
                <v-layout row align-center style="margin-bottom: 12px">
                  <v-icon small class="q-orange" style="margin-right: 8px"
                    >build</v-icon
                  >
                  <span style="font-weight: 600; font-size: 14px">
                    Servizi
                    <span
                      v-if="activeSelectedService(item).length > 0"
                      class="q-orange--text"
                    >
                      ({{ activeSelectedService(item).length }}/{{
                        services[item.idEmployee]
                          ? services[item.idEmployee].length
                          : 0
                      }})
                    </span>
                  </span>
                  <v-spacer></v-spacer>
                  <v-btn
                    icon
                    x-small
                    class="q-orange-bk q-text-whitesmoke"
                    @click="showDialogServizi(item)"
                    style="margin: 0"
                  >
                    <v-icon x-small>edit</v-icon>
                  </v-btn>
                </v-layout>

                <v-layout wrap row style="gap: 6px; overflow: hidden; min-height: 70px; align-content: flex-start">
                  <template
                    v-if="
                      activeSelectedService(item).length > 0 &&
                      activeSelectedService(item).length <
                        services[item.idEmployee].length
                    "
                  >
                    <span
                      v-for="(item1, idx) in activeSelectedService(item).slice(0, 3)"
                      :key="idx"
                      style="
                        display: inline-block;
                        background-color: #ff6f00;
                        color: white;
                        padding: 4px 8px;
                        border-radius: 4px;
                        font-size: 12px;
                        margin-bottom: 4px;
                      "
                    >
                      {{
                        services
                          .filter(
                            (x) =>
                              x !== null && x.find((y) => y.idPrice == item1)
                          )[0]
                          .find((x) => x.idPrice == item1).description
                      }}
                    </span>
                    <span
                      v-if="activeSelectedService(item).length > 3"
                      style="
                        display: inline-block;
                        background-color: #bdbdbd;
                        color: white;
                        padding: 4px 8px;
                        border-radius: 4px;
                        font-size: 12px;
                        margin-bottom: 4px;
                      "
                    >
                      +{{ activeSelectedService(item).length - 3 }} altri
                    </span>
                  </template>
                  <span
                    v-if="
                      activeSelectedService(item).length === 0 ||
                      activeSelectedService(item).length ===
                        services[item.idEmployee].length
                    "
                    style="color: #999; font-size: 13px; padding: 4px 0"
                  >
                    Può fare tutti i servizi
                  </span>
                </v-layout>
              </v-layout>

              <v-divider style="margin: 12px 0"></v-divider>

              <v-layout row align-center style="margin-bottom: 8px">
                <v-icon small class="q-orange" style="margin-right: 8px"
                  >access_time</v-icon
                >
                <span style="font-weight: 600; font-size: 14px"
                  >Orari personalizzati</span
                >
                <v-spacer></v-spacer>
                <v-btn
                  icon
                  x-small
                  class="q-orange-bk q-text-whitesmoke"
                  @click="showDialogOrari(item)"
                  style="margin: 0"
                >
                  <v-icon x-small>edit</v-icon>
                </v-btn>
              </v-layout>
              <span
                v-if="
                  !timeOverrides[item.idEmployee] ||
                  timeOverrides[item.idEmployee].length === 0
                "
                style="color: #999; font-size: 13px; padding: 4px 0; height: 80px;" 
              >
                Usa orari del negozio
              </span>
              <v-layout v-else column style="gap: 4px; height: 80px; overflow-y: auto; padding-right: 4px;">
                <div
                  v-for="(group, gIdx) in groupedTimeOverrides[item.idEmployee]"
                  :key="gIdx"
                  style="
                    font-size: 12px;
                    display: flex;
                    align-items: center;
                    gap: 6px;
                  "
                >
                  <span
                    style="
                      display: inline-block;
                      background-color: #ff6f00;
                      color: white;
                      padding: 2px 6px;
                      border-radius: 4px;
                      min-width: 52px;
                      text-align: center;
                      flex-shrink: 0;
                    "
                  >
                    {{
                      group.dayOfWeek === -1
                        ? "Tutti"
                        : dayOfWeekOptions.find(
                            (d) => d.value === group.dayOfWeek
                          )
                        ? dayOfWeekOptions
                            .find((d) => d.value === group.dayOfWeek)
                            .label.substring(0, 3)
                        : group.dayOfWeek
                    }}
                  </span>
                  <span style="color: #333">{{ group.slots.join(" | ") }}</span>
                </div>
              </v-layout>

              <v-divider style="margin: 12px 0"></v-divider>

              <v-layout wrap row align-center style="gap: 8px; margin-bottom: 12px">
                <v-icon small style="color: #999">visibility_off</v-icon>
                <v-switch
                  v-model="item.hiddenInApp"
                  :label="`Nascondi in App`"
                  @change="saveEmp(item.idEmployee, item)"
                  style="margin: 0; padding: 0"
                  dense
                  hide-details
                ></v-switch>
              </v-layout>

              <v-divider style="margin: 12px 0"></v-divider>

              <v-layout row align-center style="gap: 8px;">
                <v-icon small class="q-orange" style="margin-right: 8px">timer</v-icon>
                <span style="font-weight: 600; font-size: 14px; flex: 1">Tempo prenotazione (min)</span>
                <v-text-field
                  v-model.number="item.minIntervalloEmployee"
                  type="number"
                  min="0"
                  step="1"
                  style="max-width: 80px; margin: 0; padding: 0"
                  hide-details
                  dense
                  :placeholder="!item.minIntervalloEmployee || item.minIntervalloEmployee === 0 ? 'Predefinito' : ''"
                  :error="item.minIntervalloEmployee > 0 && item.minIntervalloEmployee < 10"
                  @change="saveEmp(item.idEmployee, item)"
                ></v-text-field>
              </v-layout>
              <div
                v-if="!item.minIntervalloEmployee || item.minIntervalloEmployee === 0"
                style="font-size: 11px; color: #999; text-align: right; margin-top: 2px;"
              >
                Usa il tempo predefinito del negozio
              </div>
              <div
                v-if="item.minIntervalloEmployee > 0 && item.minIntervalloEmployee < 10"
                style="font-size: 11px; color: #f44336; text-align: right; margin-top: 2px;"
              >
                Il valore minimo è 10 minuti
              </div>
            </v-card-text>
            <v-card-text v-show="isUploading">
              <v-progress-linear
                :value="fileUploadProgress"
              ></v-progress-linear>
            </v-card-text>
          </v-card>
        </v-flex>
      </template>
      <my-upload
        imgFormat="jpg"
        field="files"
        noCircle
        @crop-success="cropSuccess"
        @crop-upload-success="cropUploadSuccess"
        @crop-upload-fail="cropUploadFail"
        v-model="show"
        :headers="imgHeaders"
        :url="targetUrl"
        :width="512"
        :height="512"
        :withCredentials="true"
        langType="it"
      ></my-upload>
    </draggable>
    <!-- Quadrato add-employee rimosso, descrizione rimane solo in alto -->
    <v-dialog v-model="dialog" width="550">
      <v-card>
        <v-card-title class="headline grey lighten-2" primary-title>
          Conferma cancellazione — {{ selectedItem && selectedItem.name ? selectedItem.name : '' }}
        </v-card-title>
        <v-card-text>
          <div v-if="deleteReservations === null" style="text-align:center; padding: 24px;">
            <v-progress-circular indeterminate color="orange"></v-progress-circular>
            <div style="margin-top: 8px; color: #555; font-size: 13px;">Caricamento prenotazioni...</div>
          </div>
          <template v-else>
            <div v-if="deleteReservations.length === 0">
              <p style="color: #555">Sei sicuro di voler eliminare questo dipendente? L'operazione non è reversibile.</p>
              <p style="color: #888; font-size: 12px">{{ getString('Se vuoi solo cambiare il nome o la foto, non cancellarlo ma usa le funzioni apposite') }}</p>
            </div>
            <div v-else>
              <h4 style="color: #e53935; margin-bottom: 8px; display: flex; align-items: center; gap: 6px;">
                <v-icon small style="color: #e53935">warning</v-icon>
                {{ selectedItem.name }} ha {{ deleteReservations.length }} prenotazioni attive
              </h4>
              <p style="color: #555; font-size: 13px; margin-bottom: 8px;">Se elimini il dipendente queste prenotazioni verranno cancellate.</p>
              <p style="color: #e53935">Sei sicuro di voler continuare?</p>
              <div style="max-height: 200px; overflow-y: auto; border: 1px solid #eee; border-radius: 4px;">
                <table style="width: 100%; border-collapse: collapse; font-size: 13px;">
                  <thead style="background: #f5f5f5;">
                    <tr>
                      <th style="padding: 6px 8px; text-align: left;">Data</th>
                      <th style="padding: 6px 8px; text-align: left;">Servizio</th>
                      <th style="padding: 6px 8px; text-align: left;">Cliente</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(r, i) in deleteReservations" :key="i" :style="i % 2 === 0 ? '' : 'background:#fafafa'">
                      <td style="padding: 6px 8px;">{{ formatDeleteDate(r.dateAndTime) }}</td>
                      <td style="padding: 6px 8px;">{{ r.service }}</td>
                      <td style="padding: 6px 8px;">{{ r.uName }} {{ r.uSurname }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </template>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-btn class="q-orange" flat @click="dialog = false">{{ getString('Annulla') }}</v-btn>
          <v-spacer></v-spacer>
          <v-btn
            v-if="deleteReservations !== null"
            :class="deleteReservations.length > 0 ? 'red darken-1 white--text' : 'q-orange-bk q-text-whitesmoke'"
            flat
            @click="deleteEmp"
          >
            {{ deleteReservations.length > 0 ? 'Elimina comunque' : getString('Conferma') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogServizi" width="700">
      <v-card>
        <v-card-title class="headline grey lighten-2" primary-title>{{
          getString("Servizi personalizzati")
        }}</v-card-title>
        <v-card-text>
          <label
            >Seleziona i servizi che questo dipendente può fare. Se la durata
            del servizio differisce da quello globale inserisci il valore nella
            colonna tempo o lascia 0 per usare il valore di base.</label
          >
          <v-data-table
            :rows-per-page-items="[-1]"
            :headers="[
              { text: getString('Attivo'), value: 'active', sortable: false },
              { text: getString('Nome'), value: 'description', width: '50%' },
              { text: getString('Tempo globale'), value: 'timeInMinute' },
              {
                text: getString('Tempo'),
                value: 'custom',
              },
            ]"
            :items="services[selectedItem.idEmployee]"
            item-key="idPrice"
            hide-actions
            :rows-per-page-text="getString('Date per pagina')"
            :no-data-text="getString('Dati non disponibili')"
            class="elevation-0 row-height-50"
          >
            <template slot="items" slot-scope="props">
              <tr style="max-height: 100px; overflow: hidden">
                <td class="text-xs-left">
                  <v-checkbox
                    v-model="props.item.active"
                    :true-value="1"
                    :false-value="0"
                  ></v-checkbox>
                </td>
                <td class="text-xs-left">{{ props.item.description }}</td>
                <td class="text-xs-left">{{ props.item.timeInMinute }}</td>
                <td class="text-xs-left">
                  <v-text-field
                    style="padding: 0"
                    v-model="props.item.customTime"
                    color="red darken-1"
                    :rules="tenMinRule"
                    :placeholder="getString('0')"
                  ></v-text-field>
                </td>
              </tr>
            </template>
          </v-data-table>
          <b>{{ getString("*I tempi indicati sono in minuti") }}</b>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-btn class="q-orange" flat @click="dialogServizi = false">{{
            getString("Annulla")
          }}</v-btn>
          <v-spacer></v-spacer>
          <v-btn
            class="q-orange-bk q-text-whitesmoke"
            flat
            @click="saveService"
            >{{ getString("Salva") }}</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogOrari" width="750">
      <v-card>
        <v-card-title class="headline grey lighten-2" primary-title>
          Orari personalizzati —
          {{ selectedItem && selectedItem.name ? selectedItem.name : "" }}
        </v-card-title>
        <v-card-text>
          <p style="color: #555; font-size: 13px; margin-bottom: 16px">
            Definisci gli orari di lavoro di questo dipendente. Usa
            <strong>Tutti i giorni</strong> come regola generale, oppure
            specifica un giorno preciso (che avrà la priorità).
          </p>
          <v-data-table
            :rows-per-page-items="[-1]"
            :headers="[
              { text: 'Giorno', value: 'dayOfWeek', width: '35%' },
              { text: 'Inizio', value: 'start', width: '25%' },
              { text: 'Fine', value: 'end', width: '25%' },
              { text: '', value: 'actions', sortable: false, width: '15%' },
            ]"
            :items="timeOverrides[selectedItem.idEmployee] || []"
            hide-actions
            :no-data-text="getString('Nessun orario personalizzato')"
            class="elevation-0"
          >
            <template slot="items" slot-scope="props">
              <tr>
                <td>
                  <v-select
                    v-model="props.item.dayOfWeek"
                    :items="dayOfWeekOptions"
                    item-text="label"
                    item-value="value"
                    style="padding: 0; font-size: 13px"
                    hide-details
                    dense
                  ></v-select>
                </td>
                <td>
                  <v-text-field
                    v-model="props.item.startStr"
                    type="time"
                    style="padding: 0; font-size: 13px"
                    hide-details
                    dense
                  ></v-text-field>
                </td>
                <td>
                  <v-text-field
                    v-model="props.item.endStr"
                    type="time"
                    style="padding: 0; font-size: 13px"
                    hide-details
                    dense
                  ></v-text-field>
                </td>
                <td style="text-align: right; white-space: nowrap">
                  <v-tooltip left>
                    <v-btn
                     slot="activator"
                      icon
                      x-small
                      class="q-orange-bk q-text-whitesmoke"
                      @click="saveTimeOverride(props.item)"
                      style="margin-right: 4px"
                    >
                      <v-icon x-small>save</v-icon>
                    </v-btn>
                    <span>{{ getString("Salva modifiche") }}</span>
                  </v-tooltip>
                  <v-tooltip right>
                    <v-btn
                     slot="activator"
                      icon
                      x-small
                      color="red lighten-1"
                      @click="deleteTimeOverride(props.item)"
                      style="margin: 0"
                    >
                      <v-icon x-small style="color: white">delete</v-icon>
                    </v-btn>
                    <span>{{ getString("Elimina orario") }}</span>
                  </v-tooltip>
                </td>
              </tr>
            </template>
          </v-data-table>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-title
          class="grey lighten-4"
          style="font-size: 14px; font-weight: 600; padding: 12px 16px"
        >
          Aggiungi fascia oraria
        </v-card-title>
        <v-card-text style="padding-top: 8px">
          <v-layout row wrap align-center style="gap: 12px">
            <v-flex xs12 sm3>
              <v-select
                v-model="newTimeOverride.dayOfWeek"
                :items="dayOfWeekOptions"
                item-text="label"
                item-value="value"
                label="Giorno"
                hide-details
                dense
              ></v-select>
            </v-flex>
            <v-flex xs6 sm3>
              <v-text-field
                v-model="newTimeOverride.start"
                type="time"
                label="Inizio"
                hide-details
                dense
              ></v-text-field>
            </v-flex>
            <v-flex xs6 sm3>
              <v-text-field
                v-model="newTimeOverride.end"
                type="time"
                label="Fine"
                hide-details
                dense
              ></v-text-field>
            </v-flex>
            <v-flex xs12 sm2 style="text-align: right">
              <v-btn
                small
                class="q-orange-bk q-text-whitesmoke"
                @click="addTimeOverride"
              >
                <v-icon small>add</v-icon>
              </v-btn>
            </v-flex>
          </v-layout>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-btn class="q-orange" flat @click="dialogOrari = false">
            {{ getString("Chiudi") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import Utils from "../../../utils.js";
import ajax from "../../../ajax.js";
import myUpload from "vue-image-crop-upload";
import ProgressQ from "../ProgressQ";
import draggable from "vuedraggable";
var ut = new Utils();
export default {
  name: "ShopEmployees",
  props: ["shopID", "tab"],
  components: {
    draggable,
    "my-upload": myUpload,
    ProgressQ,
  },
  mounted: function () {
    this.getEmployees();
  },
  computed: {
    canAdd: function () {
      if (this.$store.getters.hasDlc("V10")) {
        if (this.employees.length > 2) {
          return false;
        }
      }
      if (this.employees.length > 12) {
        return false;
      }
      return true;
    },
    imgHeaders: function () {
      return {
        Authorization: "Bearer " + this.$store.getters.token,
      };
    },
    tenMinRule: function () {
      return [
        (v) =>
          Number.parseInt(v) >= 10 ||
          Number.parseInt(v) === 0 ||
          this.getString("Minimo 10 minuti"),
      ];
    },
    maxSort: function () {
      let max = 0;
      this.prices.forEach((element) => {
        if (element.sort > max) max = element.sort;
      });
      return max;
    },
    pwdConfirmRule: function () {
      return [
        (v) => v === this.pwd || this.getString("Le password non coincidono"),
      ];
    },
    minLenghtRule: function () {
      return [
        (v) =>
          ut.MinLengthValidate(v, 8) ||
          this.getString("Password troppo corta, almeno 8 caratteri"),
      ];
    },
    notEmpty: function () {
      return [(v) => !!v || this.getString("Campo richiesto")];
    },
    urlRule: function () {
      return [(v) => ut.validateUrl(v) || this.getString("Url non valido")];
    },
    emailRule: function () {
      return [
        (v) => !!v || this.getString("Campo richiesto"),
        (v) => ut.ValidateEmail(v) || this.getString("Email non valida"),
      ];
    },
    numRule: function () {
      return [
        (v) => !!v || this.getString("Campo richiesto"),
        (v) => ut.ValidateNumber(v) || this.getString("Numero non valido"),
      ];
    },
    saveAlert: function () {
      let val = this.image != null;

      if (val) {
        this.$store.commit("isModifying");
      } else {
        this.$store.commit("notIsModifying");
      }
      return val;
    },
    sortOptions: function () {
      return {
        handle: ".handle",
        ghostClass: "drag-ghost",
        chosenClass: "drag-chosen",
        animation: 200,
        scrollSensitivity: 300,
        scrollSpeed: 20,
      };
    },
    sortOrder: function () {
      let temp = [];
      let i = 0;
      this.prices.forEach((e) => {
        temp[i++] = e.sort;
      });
      return temp;
    },
    draggableEmployees: {
      get: function () {
        return this.employees
          ? this.employees.filter((e) => e.idEmployee !== -1)
          : [];
      },
      set: function (val) {
        // preserve add-item (idEmployee === -1) if present
        const addItem = this.employees
          ? this.employees.find((e) => e.idEmployee === -1)
          : null;
        this.employees = val.slice();
        if (addItem) this.employees.push(addItem);
      },
    },
    responsiveGridClass: function () {
      return this.draggableEmployees.length < 5 ? "xl3" : "xl2";
    },
    groupedTimeOverrides: function () {
      const result = {};
      Object.keys(this.timeOverrides).forEach((empId) => {
        const rows = this.timeOverrides[empId] || [];
        const grouped = [];
        const seen = {};
        rows.forEach((ov) => {
          const key = ov.dayOfWeek;
          if (!seen[key]) {
            seen[key] = { dayOfWeek: ov.dayOfWeek, slots: [] };
            grouped.push(seen[key]);
          }
          seen[key].slots.push(
            (ov.startStr || (ov.start ? ov.start.substring(0, 5) : "")) +
              " – " +
              (ov.endStr || (ov.end ? ov.end.substring(0, 5) : ""))
          );
        });
        result[empId] = grouped;
      });
      return result;
    },
  },
  data: () => {
    return {
      h: null,
      hidden: false,
      image: null,
      fileUploadProgress: 0,
      isLoading: false,
      isUploading: false,
      employees: [],
      prices: [],
      maxEmployees: 0,
      nameShow: [],
      newName: "",
      hiddenInApp: [],
      show: false,
      formats: "",
      targetUrl: "",
      shopLoad: false,
      dialog: false,
      dialogServizi: false,
      selectedItem: 0,
      selectedService: [],
      generating: false,
      services: [],
      deleteReservations: null,
      dialogOrari: false,
      timeOverrides: [],
      newTimeOverride: { dayOfWeek: -1, start: "09:00", end: "18:00" },
      dayOfWeekOptions: [
        { value: -1, label: "Tutti i giorni" },
        { value: 1, label: "Lunedì" },
        { value: 2, label: "Martedì" },
        { value: 3, label: "Mercoledì" },
        { value: 4, label: "Giovedì" },
        { value: 5, label: "Venerdì" },
        { value: 6, label: "Sabato" },
        { value: 0, label: "Domenica" },
      ],
    };
  },
  watch: {
    tab: function () {
      if (this.tab === 4) this.getEmployees();
    },
    shopID: function () {
      if (this.shopID > 0) {
        this.getEmployees();
      }
    },
  },
  methods: {
    activeSelectedService: function (item) {
      const self = this;
      if (this.selectedService) {
        const services = this.selectedService[item.idEmployee].filter(
          (x) =>
            self.services[item.idEmployee].filter((y) => y.idPrice === x)[0]
              .active === 1
        );

        return services;
      }
      return [];
    },
    saveEmp: function (idEmp, item) {
      let self = this;
      if (item.minIntervalloEmployee > 0 && item.minIntervalloEmployee < 10) {
        self.$emit("siteAlert", "Il tempo prenotazione deve essere 0 (predefinito) oppure maggiore di 10 minuti.");
        return;
      }
      self.isLoading = true;
      var data = new FormData();
      data.append("json", JSON.stringify(item));
      ajax.axios
        .put(
          ajax.baseUrl() +
            "/admin/shops/shop/" +
            this.shopID +
            "/employees/employee/" +
            idEmp,
          item,
          {
            headers: self.$store.getters.tokenHeader,
            withCredentials: true,
          }
        )
        .then(function (response) {
          ajax.validateToken(response.headers, self.$store);
          self.$emit("siteAlertSuccess", response.data.data);
          self.isLoading = false;
        })
        .catch(function (error) {
          var auth = ajax.checkAuth(error, self.$store, self.$router);
          self.dialog = false;
          self.selectedItem = null;
          self.isLoading = false;
          self.$emit(
            "siteAlert",
            auth
              ? self.getString("Non hai l'autorizzazione")
              : error.response.data.errorMessage
          );
        });
    },
    updateSort: function () {
      let self = this;
      // Rimuovi l'elemento "aggiungi" dal salvataggio dell'ordine
      const employeesToSort = self.employees.filter((e) => e.idEmployee !== -1);
      const sortData = employeesToSort.map((emp, index) => ({
        idEmployee: emp.idEmployee,
        sort: index,
      }));

      ajax.axios
        .post(
          ajax.baseUrl() +
            "/admin/shops/shop/" +
            this.shopID +
            "/employees/updateSort",
          { employees: sortData },
          {
            headers: {
              Authorization: "Bearer " + self.$store.getters.token,
            },
            withCredentials: false,
          }
        )
        .then(function (response) {
          ajax.validateToken(response.headers, self.$store);
          self.$emit("siteAlertSuccess", "Ordine aggiornato");
        })
        .catch(function (error) {
          console.log(error);
          var auth = ajax.checkAuth(error, self.$store, self.$router);
          self.$emit(
            "siteAlert",
            auth
              ? self.getString("Non hai l'autorizzazione")
              : error.response.data.errorMessage
          );
        });
    },
    // saveServices: function (idEmp) {
    //   let self = this;
    //   self.isLoading = true;
    //   var data = new FormData();
    //   data.append("serviceSelected", self.selectedService[idEmp]);
    //   ajax.axios
    //     .put(
    //       ajax.baseUrl() +
    //         "/admin/shops/shop/" +
    //         this.shopID +
    //         "/employees/" +
    //         idEmp,
    //       data,
    //       {
    //         headers: {
    //           "Content-Type": "multipart/form-data",
    //           Authorization: "Bearer " + self.$store.getters.token,
    //         },
    //         withCredentials: false,
    //       }
    //     )
    //     .then(function (response) {
    //       ajax.validateToken(response.headers, self.$store);
    //       self.$emit("siteAlertSuccess", response.data.data);
    //       self.isLoading = false;
    //     })
    //     .catch(function (error) {
    //       var auth = ajax.checkAuth(error, self.$store, self.$router);
    //       self.dialog = false;
    //       self.selectedItem = null;
    //       self.$emit(
    //         "siteAlert",
    //         auth
    //           ? self.getString("Non hai l'autorizzazione")
    //           : error.response.data.errorMessage
    //       );
    //     });
    // },
    saveService: function () {
      let self = this;
      self.isLoading = true;
      ajax.axios
        .put(
          ajax.baseUrl() +
            "/admin/shops/shop/" +
            this.shopID +
            "/employees/" +
            self.selectedItem.idEmployee +
            "/customize",
          {
            services: self.services[self.selectedItem.idEmployee].map((e) => {
              return [e.idPrice, e.customTime, e.active ? 1 : 0];
            }),
          },
          {
            headers: {
              Authorization: "Bearer " + self.$store.getters.token,
            },
            withCredentials: false,
          }
        )
        .then(function (response) {
          ajax.validateToken(response.headers, self.$store);
          self.$emit("siteAlertSuccess", response.data.data);
          self.dialogServizi = false;
          self.isLoading = false;
        })
        .catch(function (error) {
          var auth = ajax.checkAuth(error, self.$store, self.$router);
          self.dialogServizi = false;
          self.isLoading = false;
          self.$emit(
            "siteAlert",
            auth
              ? self.getString("Non hai l'autorizzazione")
              : error.response.data.errorMessage
          );
        });
    },
    deleteEmp: function () {
      let self = this;
      const force = self.deleteReservations && self.deleteReservations.length > 0;
      ajax.axios
        .delete(
          ajax.baseUrl() +
            "/admin/shops/shop/" +
            this.shopID +
            "/employees/employee/" +
            self.selectedItem.idEmployee +
            "/delete" + (force ? '?force=true' : ''),
          {
            headers: {
              Authorization: "Bearer " + self.$store.getters.token,
            },
            withCredentials: false,
          }
        )
        .then(function (response) {
          ajax.validateToken(response.headers, self.$store);
          self.$emit("siteAlertSuccess", response.data.data);
          self.dialog = false;
          self.selectedItem = 0;
          self.deleteReservations = null;
          self.getEmployees();
        })
        .catch(function (error) {
          var auth = ajax.checkAuth(error, self.$store, self.$router);
          self.dialog = false;
          self.selectedItem = 0;
          self.deleteReservations = null;
          self.$emit(
            "siteAlert",
            auth
              ? self.getString("Non hai l'autorizzazione")
              : error.response.data.errorMessage
          );
        });
    },
    getServices: function (idEmp) {
      let self = this;
      self.isLoading = true;
      ajax.axios
        .get(
          ajax.baseUrl() +
            "/admin/shops/shop/" +
            self.shopID +
            "/employee/" +
            idEmp +
            "/prices",
          {
            headers: {
              Authorization: "Bearer " + self.$store.getters.token,
            },
            withCredentials: true,
          }
        )
        .then(function (response) {
          ajax.validateToken(response.headers, self.$store);
          self.services[idEmp] = response.data.data;
          self.selectedService[idEmp] = [];
          for (const p of response.data.data) {
            self.selectedService[idEmp].push(p.idPrice);
          }
          self.selectedService.push(0);
          self.selectedService.pop(0);
          self.isLoading = false;
        })
        .catch(function (error) {
          console.log(error);
          var auth = ajax.checkAuth(error, self.$store, self.$router);
          self.generating = false;
          self.$emit(
            "siteAlert",
            auth
              ? self.getString("Non hai l'autorizzazione")
              : error.response.data.errorMessage
          );
        });
    },
    generate: function () {
      let self = this;
      if (!this.generating) {
        self.generating = true;
        ajax.axios
          .post(
            ajax.baseUrl() +
              "/admin/shops/shop/" +
              this.shopID +
              "/employees/employee/generate",
            {},
            {
              headers: {
                Authorization: "Bearer " + self.$store.getters.token,
              },
              withCredentials: true,
            }
          )
          .then(function (response) {
            ajax.validateToken(response.headers, self.$store);
            self.getEmployees();
            self.generating = false;
          })
          .catch(function (error) {
            var auth = ajax.checkAuth(error, self.$store, self.$router);
            self.generating = false;
            self.$emit(
              "siteAlert",
              auth
                ? self.getString("Non hai l'autorizzazione")
                : error.response.data.errorMessage
            );
          });
      }
    },
    showDialogServizi: function (item) {
      this.selectedItem = item;
      this.dialogServizi = true;
    },
    showDialogOrari: function (item) {
      this.selectedItem = item;
      this.newTimeOverride = { dayOfWeek: -1, start: "09:00", end: "18:00" };
      this.getTimeOverrides(item);
      this.dialogOrari = true;
    },
    getTimeOverrides: function (item) {
      let self = this;
      ajax.axios
        .get(
          ajax.baseUrl() +
            "/admin/shops/shop/" +
            self.shopID +
            "/employees/" +
            item.idEmployee +
            "/timeoverride",
          {
            headers: { Authorization: "Bearer " + self.$store.getters.token },
            withCredentials: false,
          }
        )
        .then(function (response) {
          ajax.validateToken(response.headers, self.$store);
          const rows = (response.data.data || []).map((r) => ({
            ...r,
            startStr: r.start ? r.start.substring(0, 5) : "",
            endStr: r.end ? r.end.substring(0, 5) : "",
          }));
          self.$set(self.timeOverrides, item.idEmployee, rows);
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    validateTimeOverride: function (dayOfWeek, start, end, excludeId) {
      const existing = (
        this.timeOverrides[this.selectedItem.idEmployee] || []
      ).filter((r) => r.dayOfWeek === dayOfWeek && r.id !== excludeId);
      if (existing.length >= 2) {
        this.$emit(
          "siteAlert",
          "Ogni giorno può avere al massimo 2 fasce orarie."
        );
        return false;
      }
      const toMin = (t) => {
        const parts = t.split(":");
        return parseInt(parts[0]) * 60 + parseInt(parts[1]);
      };
      const s = toMin(start);
      const e = toMin(end);
      if (s >= e) {
        this.$emit(
          "siteAlert",
          "L'orario di inizio deve essere precedente all'orario di fine."
        );
        return false;
      }
      for (const r of existing) {
        const rs = toMin(
          r.startStr || (r.start ? r.start.substring(0, 5) : "00:00")
        );
        const re = toMin(r.endStr || (r.end ? r.end.substring(0, 5) : "00:00"));
        if (s < re && e > rs) {
          this.$emit("siteAlert", "Le fasce orarie non possono sovrapporsi.");
          return false;
        }
      }
      return true;
    },
    addTimeOverride: function () {
      let self = this;
      if (!self.newTimeOverride.start || !self.newTimeOverride.end) return;
      if (
        !self.validateTimeOverride(
          self.newTimeOverride.dayOfWeek,
          self.newTimeOverride.start,
          self.newTimeOverride.end,
          null
        )
      )
        return;
      ajax.axios
        .post(
          ajax.baseUrl() +
            "/admin/shops/shop/" +
            self.shopID +
            "/employees/" +
            self.selectedItem.idEmployee +
            "/timeoverride",
          {
            dayOfWeek: self.newTimeOverride.dayOfWeek,
            start: self.newTimeOverride.start + ":00",
            end: self.newTimeOverride.end + ":00",
          },
          {
            headers: { Authorization: "Bearer " + self.$store.getters.token },
            withCredentials: false,
          }
        )
        .then(function (response) {
          ajax.validateToken(response.headers, self.$store);
          self.$emit("siteAlertSuccess", "Fascia oraria aggiunta");
          self.newTimeOverride = {
            dayOfWeek: -1,
            start: "09:00",
            end: "18:00",
          };
          self.getTimeOverrides(self.selectedItem);
        })
        .catch(function (error) {
          var auth = ajax.checkAuth(error, self.$store, self.$router);
          self.$emit(
            "siteAlert",
            auth
              ? self.getString("Non hai l'autorizzazione")
              : error.response.data.errorMessage
          );
        });
    },
    saveTimeOverride: function (override) {
      let self = this;
      if (
        !self.validateTimeOverride(
          override.dayOfWeek,
          override.startStr,
          override.endStr,
          override.id
        )
      )
        return;
      ajax.axios
        .put(
          ajax.baseUrl() +
            "/admin/shops/shop/" +
            self.shopID +
            "/employees/" +
            self.selectedItem.idEmployee +
            "/timeoverride/" +
            override.id,
          {
            dayOfWeek: override.dayOfWeek,
            start: override.startStr + ":00",
            end: override.endStr + ":00",
          },
          {
            headers: { Authorization: "Bearer " + self.$store.getters.token },
            withCredentials: false,
          }
        )
        .then(function (response) {
          ajax.validateToken(response.headers, self.$store);
          self.$emit("siteAlertSuccess", "Fascia oraria aggiornata");
        })
        .catch(function (error) {
          var auth = ajax.checkAuth(error, self.$store, self.$router);
          self.$emit(
            "siteAlert",
            auth
              ? self.getString("Non hai l'autorizzazione")
              : error.response.data.errorMessage
          );
        });
    },
    deleteTimeOverride: function (override) {
      let self = this;
      ajax.axios
        .delete(
          ajax.baseUrl() +
            "/admin/shops/shop/" +
            self.shopID +
            "/employees/" +
            self.selectedItem.idEmployee +
            "/timeoverride/" +
            override.id,
          {
            headers: { Authorization: "Bearer " + self.$store.getters.token },
            withCredentials: false,
          }
        )
        .then(function (response) {
          ajax.validateToken(response.headers, self.$store);
          self.$emit("siteAlertSuccess", "Fascia oraria eliminata");
          self.getTimeOverrides(self.selectedItem);
        })
        .catch(function (error) {
          var auth = ajax.checkAuth(error, self.$store, self.$router);
          self.$emit(
            "siteAlert",
            auth
              ? self.getString("Non hai l'autorizzazione")
              : error.response.data.errorMessage
          );
        });
    },
    showDelete: function (item) {
      this.selectedItem = item;
      this.deleteReservations = null;
      this.dialog = true;
      let self = this;
      ajax.axios
        .get(
          ajax.baseUrl() +
            '/admin/shops/shop/' +
            self.shopID +
            '/employees/employee/' +
            item.idEmployee +
            '/reservations',
          {
            headers: { Authorization: 'Bearer ' + self.$store.getters.token },
            withCredentials: false,
          }
        )
        .then(function (response) {
          ajax.validateToken(response.headers, self.$store);
          self.deleteReservations = response.data.data || [];
        })
        .catch(function () {
          self.deleteReservations = [];
        });
    },
    formatDeleteDate: function (dt) {
      if (!dt) return '';
      const d = new Date(dt);
      return d.toLocaleDateString('it-IT') + ' ' + d.toLocaleTimeString('it-IT', { hour: '2-digit', minute: '2-digit' });
    },
    showPicker: function (item) {
      this.show = !this.show;
      this.targetUrl = this.getUrl(item);
    },
    getUrl: function (item) {
      return (
        ajax.baseUrl() +
        "/admin/shops/shop/" +
        this.shopID +
        "/employees/employee/" +
        item.idEmployee +
        "/img"
      );
    },
    showTheName: function (i, item) {
      let self = this;
      this.$set(this.nameShow, i, !this.nameShow[i]);
      if (this.newName === "") this.newName = item.name;
      else {
        ajax.axios
          .put(
            ajax.baseUrl() +
              "/admin/shops/shop/" +
              this.shopID +
              "/employees/employee/" +
              item.idEmployee +
              "/name",
            {
              name: self.newName,
            },
            {
              headers: {
                Authorization: "Bearer " + self.$store.getters.token,
              },
              withCredentials: false,
            }
          )
          .then(function (response) {
            ajax.validateToken(response.headers, self.$store);
            self.$emit("siteAlertSuccess", response.data.data);
            item.name = self.newName;
            self.newName = "";
          })
          .catch(function (error) {
            var auth = ajax.checkAuth(error, self.$store, self.$router);
            self.$emit(
              "siteAlert",
              auth
                ? self.getString("Non hai l'autorizzazione")
                : error.response.data.errorMessage
            );
          });
      }
    },
    getEmployees: function () {
      let self = this;

      self.shopLoad = true;
      if (self.shopID > 0) {
        ajax.axios
          .get(
            ajax.baseUrl() + "/admin/shops/shop/" + self.shopID + "/employees",
            {
              headers: self.$store.getters.tokenHeader,
              withCredentials: true,
            }
          )
          .then(function (response) {
            ajax.validateToken(response.headers, self.$store);

            self.employees = response.data.data.list;
            self.maxEmployees = response.data.data.maxEmployees;

            self.employees.forEach((e) => {
              self.nameShow.push(false);
            });

            for (const emp of self.employees) {
              self.getServices(emp.idEmployee);
              self.getTimeOverrides(emp);
            }
            self.employees.push({
              idEmployee: -1,
            });
            self.newName = "";
            self.shopLoad = false;
          })
          .catch(function (error) {
            console.log(error);
            var auth = ajax.checkAuth(error, self.$store, self.$router);
            self.shopLoad = false;
            self.$emit(
              "siteAlert",
              auth
                ? self.getString("Non hai l'autorizzazione")
                : error.response.data.errorMessage
            );
          });
      }
    },
    defaultAvatar: function (item) {
      if (
        item.photo === null ||
        item.photo === "/images/u_placeholder.jpg" ||
        item.photo === "images/u_placeholder.jpg"
      ) {
        item.photo = "/../../../static/img/default-avatar.png";
        return item.photo;
      } else
        var photoUrl = item.photo.startsWith('http') ? item.photo : ajax.baseUrl() + item.photo;
        return photoUrl + "?t=" + new Date().getSeconds();
    },
    updateSort: function () {
      let self = this;
      // Rimuovi l'elemento "aggiungi" dal salvataggio dell'ordine
      const employeesToSort = self.employees.filter((e) => e.idEmployee !== -1);
      const sortData = employeesToSort.map((emp, index) => ({
        idEmployee: emp.idEmployee,
        sort: index,
      }));

      ajax.axios
        .post(
          ajax.baseUrl() +
            "/admin/shops/shop/" +
            this.shopID +
            "/employees/updateSort",
          { employees: sortData },
          {
            headers: {
              Authorization: "Bearer " + self.$store.getters.token,
            },
            withCredentials: false,
          }
        )
        .then(function (response) {
          ajax.validateToken(response.headers, self.$store);
          self.$emit("siteAlertSuccess", "Ordine aggiornato");
        })
        .catch(function (error) {
          console.log(error);
          var auth = ajax.checkAuth(error, self.$store, self.$router);
          self.$emit(
            "siteAlert",
            auth
              ? self.getString("Non hai l'autorizzazione")
              : error.response.data.errorMessage
          );
        });
    },
    getString: function (key) {
      let page = this.$store.state.currentTranslator.getString(key);
      return page;
    },
    /**
     * crop success
     *
     * [param] imgDataUrl
     * [param] field
     */
    cropSuccess(imgDataUrl, field) {
      // item.photo = imgDataUrl
    },
    /**
     * upload success
     *
     * [param] jsonData  server api return data, already json encode
     * [param] field
     */
    cropUploadSuccess(jsonData, field) {
      this.getEmployees();
    },
    /**
     * upload fail
     *
     * [param] status    server api return error status, like 500
     * [param] field
     */
    cropUploadFail(status, field) {},
  },
};
</script>

<style scoped>
.avatar-img {
  width: 100%;
  object-fit: contain;
  transition: max-height 0.3s ease-in-out;
}

.dash-card {
  display: flex;
  flex-direction: column;
  height: 100%;
}

.draggable-grid > .v-flex {
  display: flex;
  flex-direction: column;
}

.draggable-grid > .v-flex > .dash-card {
  flex: 1;
}

.dash-card > .v-card__text {
  flex: 1;
  display: flex;
  flex-direction: column;
}

.save-alert {
  animation-name: saveAlertAnimation !important;
  animation-timing-function: linear !important;
  animation-duration: 1s !important;
  animation-iteration-count: infinite !important;
}
.loading {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: grid;
  z-index: 1000;
}
.v-data-table.row-height-50 td {
  height: 18px !important;
}
.loading .background {
  opacity: 0.5;
  background: whitesmoke;
  z-index: 1500;
}
@keyframes saveAlertAnimation {
  0% {
    background-color: transparent;
  }

  50% {
    background-color: bisque;
  }

  100% {
    background-color: transparent;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/backend/pieces/ShopEmployees.vue